import script from "./TableHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TableHeader.vue?vue&type=script&setup=true&lang=js"

import "./TableHeader.vue?vue&type=style&index=0&id=dcbf0f22&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcbf0f22"]])

export default __exports__